import React, { useContext } from 'react';
import ImageComponent from '../../../atoms/Image/index';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import MENU_CONSTANT from '../MenuConstants/MenuConstants';
import Finger_Lickin_Image from '../../../styles/staticAssets/images/finger_lickin.svg';
import BlackRightArrow from '../../../styles/staticAssets/images/black_right_arrow.svg';
import { withRouter, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserOrderContext } from '../../../context/context';
import { getFullImagePath } from '../../../common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import reject from 'lodash/reject';

const MenuDataTile = ({ item, tenantReducer, classNames, navigateToPLP, children }) => {
  return (
    <Link
      className='menu-cards'
      key={item.name}
      data-testid={`tiles-click-${item.name}`}
      onClick={() => navigateToPLP(item)}
      tabIndex='0'
      to={`menu/${item.url}`}
    >
      <ImageComponent
        data-testid=''
        srcFile={getFullImagePath(item.imageName, tenantReducer, false, true)}
        defaultPath={getFullImagePath(null, tenantReducer, true)}
        className={classNames}
      />
      {children}
    </Link>
  );
};

const GenericMenuCategoriesItems = props => {
  const { SELECTED_TILE_DATA = '' } = START_ORDER_CONSTANTS;
  const { isMobile } = props;
  const { FIVE_TILES, SIX_TILES, SEVEN_TILES, VIEW_ALL_MENU, MENU } = MENU_CONSTANT;
  const { flatResponse: { categories = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const menuData = reject(
    categories,
    c => c.name === 'Menu' || c.isHidden || !Object.keys(c?.productMapByProductUrl).length,
  );
  const menuLength = menuData.length;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);

  /**
   *
   * Method to navigate to plp
   */
  const navigateToPLP = selectedItem => {
    let itemName = {
      name: selectedItem.name,
    };
    //selected tile from setState
    if (Object.keys(selectedItem).length === 0) {
      itemName = {};
    }

    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: itemName } });
    localStorage.setItem('selectedTile', JSON.stringify(itemName));
    localStorage.setItem('tenantReducer', JSON.stringify(tenantReducer));
  };

  /**
   * Mehtod to get the first item of the images
   * @param {*} allImgObj - contains all image data array
   */

  /**
   * method to render five tile pattern
   */
  const drawTilesFive = () => {
    const allMenuItems = JSON.parse(JSON.stringify(menuData));
    const firstElement = allMenuItems.shift();
    return (
      <div className='d-flex' data-testid='menu-five-tiles' tabIndex='0'>
        <div className='first-of-five'>
          <Link
            className='menu-cards'
            key={firstElement.name}
            data-testid={`tiles-click-${firstElement.name}`}
            onClick={() => navigateToPLP(firstElement)}
            tabIndex='0'
            to={`menu/${firstElement.url}`}
          >
            <ImageComponent
              data-testid=''
              srcFile={getFullImagePath(firstElement.imageName, tenantReducer, false, true)}
              defaultPath={getFullImagePath(null, tenantReducer, true)}
              alt={firstElement.name || 'menu'}
              className='w-100'
            />

            <div className='menu-text'>{firstElement.name} </div>
          </Link>
        </div>
        <div className='rest-of-five'>
          {allMenuItems.map((item, ind) => {
            return (
              <div className='small-four' key={item.name}>
                <MenuDataTile
                  item={item}
                  tenantReducer={tenantReducer}
                  classNames='w-100 small-four-img'
                  navigateToPLP={navigateToPLP}
                >
                  <div className='menu-text'>{item.name} </div>
                </MenuDataTile>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const drawTilesSix = () => {
    console.log('drawTilesSixdrawTilesSix');
    let fingerLickingTile;
    const menuDataTiles = menuData.map((item, ind) => {
      return (
        <MenuDataTile
          key={item.name}
          item={item}
          tenantReducer={tenantReducer}
          classNames=''
          navigateToPLP={navigateToPLP}
        >
          <div className='menu-text'> {item.name} </div>
        </MenuDataTile>
      );
    });
    fingerLickingTile = (
      <Link
        className='full-lickin-card menu-cards'
        data-testid={`tiles-click-six`}
        onClick={() => navigateToPLP({})}
        tabIndex='0'
        to={MENU}
      >
        <ImageComponent
          data-testid=''
          srcFile={`${Finger_Lickin_Image}` || ''}
          alt={translateWithI18Next(VIEW_ALL_MENU)}
          className='double-img'
        />
        <div className='all-menu-text'>
          {' '}
          {translateWithI18Next(VIEW_ALL_MENU)}
          <span className='menu-arrow-span'>
            <ImageComponent
              srcFile={BlackRightArrow}
              alt={translateWithI18Next(VIEW_ALL_MENU)}
              className='more-arrow-img'
            />
          </span>
        </div>
      </Link>
    );

    return (
      <React.Fragment>
        {menuDataTiles}
        {fingerLickingTile}
      </React.Fragment>
    );
  };

  /**
   * mehtod to render seven patterns
   */

  const drawTilesSeven = () => {
    let fingerLickingTileSeven = null;
    const allMenuItems = JSON.parse(JSON.stringify(menuData));
    const sevenTiles = allMenuItems.slice(0, 7);
    const menuDataTiles = sevenTiles.map((item, ind) => {
      return (
        <Link
          className='menu-cards'
          key={item.name}
          data-testid={`tiles-click-${item.name}`}
          onClick={() => navigateToPLP(item)}
          tabIndex='0'
          to={`menu/${item.url}`}
        >
          <ImageComponent
            data-testid=''
            //alt={item.name || 'menu'}
            srcFile={getFullImagePath(item.imageName, tenantReducer, false, true)}
            defaultPath={getFullImagePath(null, tenantReducer, true)}
            className=''
          />
          <section className='menu-text'> {item.name} </section>
        </Link>
      );
    });
    fingerLickingTileSeven = (
      <Link
        className='single-lickin-card menu-cards'
        data-testid={`tiles-click-seven`}
        onClick={() => navigateToPLP({})}
        tabIndex='0'
        to={MENU}
      >
        <ImageComponent data-testid='' srcFile={`${Finger_Lickin_Image}` || ''} alt='' className='single-img' />
        <section className='all-menu-text'>
          {' '}
          {translateWithI18Next(VIEW_ALL_MENU)}
          <span className='menu-arrow-span'>
            <ImageComponent srcFile={BlackRightArrow} alt='' className='more-arrow-img' />
          </span>
        </section>
      </Link>
    );

    return (
      <React.Fragment>
        {menuDataTiles}
        {fingerLickingTileSeven}
      </React.Fragment>
    );
  };

  const drawTilesMobile = () => {
    let fingerLickingTile = null;
    const menuDataTiles = menuData.map((item, ind) => {
      return (
        <Link
          className='menu-cards'
          key={item.name}
          data-testid={`tiles-click-${item.name}`}
          onClick={() => navigateToPLP(item)}
          to={`menu/${item.url}`}
        >
          <ImageComponent
            data-testid=''
            srcFile={getFullImagePath(item.imageName, tenantReducer, false, true)}
            defaultPath={getFullImagePath(null, tenantReducer, true)}
            // alt={item.name || 'menu'}
            className=''
          />
          <div className='menu-text'> {item.name} </div>
        </Link>
      );
    });

    fingerLickingTile = (
      <div className='single-lickin-card menu-cards'>
        <Link
          className='full-lickin-card menu-cards'
          data-testid={`tiles-click-six`}
          onClick={() => navigateToPLP({})}
          tabIndex='0'
          to={MENU}
        >
          <ImageComponent
            data-testid=''
            srcFile={`${Finger_Lickin_Image}` || ''}
            alt={translateWithI18Next(VIEW_ALL_MENU)}
            className='mobile-single-img'
          />
          <div className='all-menu-text'>
            {' '}
            {translateWithI18Next(VIEW_ALL_MENU)}
            <ImageComponent
              srcFile={BlackRightArrow}
              alt={translateWithI18Next(VIEW_ALL_MENU)}
              className='more-arrow-img'
            />
          </div>
        </Link>
      </div>
    );
    // } else {
    //   //do nothing
    // }

    return (
      <React.Fragment>
        {menuDataTiles}
        {fingerLickingTile}
      </React.Fragment>
    );
  };
  const renderDrawTiles = () => {
    if (!isMobile && menuLength === FIVE_TILES) {
      return drawTilesFive();
    } else if (!isMobile && menuLength === SIX_TILES) {
      return drawTilesSix();
    } else if (!isMobile && menuLength >= SEVEN_TILES) {
      return drawTilesSeven();
    } else if (isMobile) {
      return drawTilesMobile();
    } else {
      return null;
    }
  };
  return renderDrawTiles();
};

export default withRouter(GenericMenuCategoriesItems);
